const translations = {
  InvoiceDeleteSucceed: 'Usunięcie faktury zostało zakończone sukcesem',
  InvoiceDeleteSucceedDescription: 'Usunięcie faktury zakończyło sie sukcesem. Numer usuniętej faktury: ',
};

export default translations;
